import "./TransportSectorNav.css";

function SectorQuickNav({ setor, modulos, atual, setTela, podeAcessarTela, alteracoesPendentes, mostrarBloqueados = false }) {
  const modulosVisiveis = mostrarBloqueados
    ? modulos
    : modulos.filter(({ tela }) => tela === atual || podeAcessarTela?.(tela));

  const navegar = (destino) => {
    if (destino === atual) return;
    if (alteracoesPendentes?.() && !window.confirm("Há dados nesta tela que ainda não foram salvos. Deseja sair mesmo assim?")) return;
    setTela(destino);
  };

  if (modulosVisiveis.length < 2) return null;

  return (
    <nav className="transport-sector-nav" aria-label={`Módulos do setor ${setor}`}>
      <span className="transport-sector-nav__label">{setor} <span>· acesso rápido</span></span>
      <div className="transport-sector-nav__links">
        {modulosVisiveis.map(({ tela, nome }) => (
          <button
            key={tela}
            type="button"
            className={`transport-sector-nav__link${tela === atual ? " transport-sector-nav__link--active" : ""}`}
            aria-current={tela === atual ? "page" : undefined}
            disabled={tela !== atual && !podeAcessarTela?.(tela)}
            title={tela !== atual && !podeAcessarTela?.(tela) ? "Sem permissão para este módulo" : undefined}
            onClick={() => navegar(tela)}
          >
            {nome}
          </button>
        ))}
      </div>
    </nav>
  );
}

export default SectorQuickNav;
